(function(){
  "use strict";
  /* מחיר, מחיר מלא ותיאור מגיעים מ-data-price, data-full ו-data-note של כל חבילה */

  /* תפריט צד */
  var mnav=document.getElementById('mnav'), burger=document.getElementById('burger');
  function menu(open){
    mnav.classList.toggle('is-on',open);
    mnav.setAttribute('aria-hidden',open?'false':'true');
    burger.setAttribute('aria-expanded',open?'true':'false');
    document.body.style.overflow=open?'hidden':'';
  }
  if(burger&&mnav){
    burger.addEventListener('click',function(){menu(!mnav.classList.contains('is-on'));});
    mnav.addEventListener('click',function(e){
      if(e.target.closest('[data-close]')||e.target.closest('a')) menu(false);
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape')menu(false);});
  }

  /* פס הודעות */
  var ANNO=[
    '&#128293; הנחה למגיעים מהמודעה: 20%',
    '&#127873; + מפצל מצית במתנה'
  ];
  var annoEl=document.getElementById('annoTxt');
  if(annoEl){
    var ai=0;
    setInterval(function(){
      annoEl.classList.add('is-out');
      setTimeout(function(){
        ai=(ai+1)%ANNO.length;
        annoEl.innerHTML=ANNO[ai];
        annoEl.classList.remove('is-out');
      },350);
    },4200);
  }

  /* גלריה */
  var slides=document.querySelectorAll('.gal__slide');
  var thumbs=document.querySelectorAll('.gal__thumb');
  thumbs.forEach(function(t){
    t.addEventListener('click',function(){
      var i=+t.dataset.i;
      slides.forEach(function(s,n){s.classList.toggle('is-on',n===i);});
      thumbs.forEach(function(x,n){x.classList.toggle('is-on',n===i);});
    });
  });

  /* חבילות */
  var opts=document.querySelectorAll('.bopt');
  var pNow=document.getElementById('pNow'), pOld=document.getElementById('pOld');
  var pSave=document.getElementById('pSave'), pNote=document.getElementById('pNote');
  var sNow=document.getElementById('sNow'), sOld=document.getElementById('sOld');
  function nis(n){ return '<bdi>'+Math.round(n)+' ₪</bdi>'; }
  function apply(el){
    var price=parseFloat(el.dataset.price), full=parseFloat(el.dataset.full);
    pNow.innerHTML=nis(price); sNow.innerHTML=nis(price);
    if(full>price){
      pOld.innerHTML=nis(full); sOld.innerHTML=nis(full);
      pOld.style.display=sOld.style.display='';
      pSave.style.display='';
      pSave.textContent='חיסכון '+Math.round((1-price/full)*100)+'%';
    } else {
      pOld.style.display=sOld.style.display='none';
      pSave.style.display='none';
    }
    pNote.innerHTML=el.dataset.note;
  }
  opts.forEach(function(el){
    el.addEventListener('click',function(){
      opts.forEach(function(o){o.classList.remove('is-sel');});
      el.classList.add('is-sel'); apply(el);
    });
  });
  apply(document.querySelector('.bopt.is-sel'));

  /* שאלות */
  document.querySelectorAll('.q__b').forEach(function(b){
    b.setAttribute('aria-expanded','false');
    b.addEventListener('click',function(){
      var open=b.parentElement.classList.toggle('is-open');
      b.setAttribute('aria-expanded',open?'true':'false');
    });
  });

  /* סרגל תחתון */
  var sticky=document.getElementById('sticky'), buy=document.getElementById('buy');
  if(sticky&&buy&&'IntersectionObserver' in window){
    new IntersectionObserver(function(e){
      sticky.classList.toggle('is-on', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
    },{threshold:0}).observe(buy);
  }
})();

/* Shopify: keep the hidden variant id in sync with the chosen bundle (shieldcam-cart.js reads .bopt.is-sel too) */
(function(){
  var form=document.getElementById('buyForm'), vid=document.getElementById('vId');
  if(!form||!vid) return;
  function sync(){
    var sel=document.querySelector('.bopt.is-sel');
    if(sel && sel.dataset.vid) vid.value=sel.dataset.vid;
  }
  sync();
  document.querySelectorAll('.bopt').forEach(function(el){ el.addEventListener('click',function(){ setTimeout(sync,0); }); });
  var b=document.getElementById('btnBuy'); if(b) b.addEventListener('click',sync);
})();
